export const AMOUNT_MONEY = ',–';
export default AMOUNT_MONEY;
